import styles from './index.module.scss'
import ModelLeftCom from './components/ModelLeftCom'
import FeedbackText from './components/FeedbackText';
import Iconfont from '@utils/Iconfont';


const PicModalLeft = (props) => {
    const { item } = props

    return (
        <div>
            <div className={styles.GoBack} onClick={() => props.onCancel()}>
                <Iconfont type="icon-LeftOutlined" className={styles.Icon} style={{ fontSize: '14px' }} />
                <span className={styles.Label}>返回</span>
            </div>
            <div className={styles.PicModalLeft}>
                <ModelLeftCom item={item} selectedInputImg={props.selectedInputImg} setSelectedInputImg={props.setSelectedInputImg} />
                <FeedbackText key={item.taskId} {...props} />
            </div>
        </div>
    )
}

export default PicModalLeft